'use client';

import Image from 'next/image';
import Link from 'next/link';

import { useAuthStore, useGlobalStore } from '@/slw/shared/stores';
import { Button } from '@/slw/shared/ui/button';

export function WhyChoose() {
  const { user } = useAuthStore();
  const { openAuthModal } = useGlobalStore();

  return (
    <section className='section-why-choose py-8 md:py-14'>
      <div className='container'>
        <div className='text-[1.5rem] md:text-[2.5rem] font-bold mb-6 md:mb-10 text-default text-center'>
          Why Clovis Classics?
        </div>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-[60px] text-default'>
          <div className='item text-center hover:[&_img]:transform-[skew(20deg)]'>
            <Image
              src='/images/icon/control.png'
              className='mx-auto transition-all duration-500'
              width={128}
              height={128}
              alt=''
            />
            <div className='font-bold mt-2 mb-4'>You&apos;re in total control</div>
            <div className='text-[0.875rem]'>
              Shop at your own pace and choose from a large selection of new and used vehicles.
            </div>
          </div>

          <div className='item text-center hover:[&_img]:transform-[skew(20deg)]'>
            <Image
              src='/images/icon/find.png'
              className='mx-auto transition-all duration-500'
              width={128}
              height={128}
              alt=''
            />
            <div className='font-bold mt-2 mb-4'>Find the right financing</div>
            <div className='text-[0.875rem]'>
              See your actual monthly payment and select the lender that fits you best.
            </div>
          </div>

          <div className='item text-center hover:[&_img]:transform-[skew(20deg)]'>
            <Image
              src='/images/icon/receiver.png'
              className='mx-auto transition-all duration-500'
              width={128}
              height={128}
              alt=''
            />
            <div className='font-bold mt-2 mb-2 md:mb-4'>Receive your car</div>
            <div className='text-[0.875rem]'>
              Schedule delivery (for used cars only) or pickup, to begin enjoying your new ride!
            </div>
          </div>
        </div>
        <div className='flex justify-center mt-8 md:mt-14'>
          {user?.id ? (
            <Link
              href={'/search-results/all-year'}
              className='font-bold rounded-[6px] bg-primary text-background uppercase
              flex items-center gap-4 md:gap-10 px-4 md:px-5 py-2 md:py-[0.75rem]
              hover:text-background! hover:bg-primary-3'
            >
              <span> BROWSE OUR CLASSIC INVENTORY</span>
              <Image src='/images/icon/plus-white.png' width={17} height={17} alt='' />
            </Link>
          ) : (
            <Button
              onClick={openAuthModal}
              className='font-bold rounded-[6px] bg-primary text-background uppercase
              flex items-center gap-4 md:gap-10 px-4 md:px-5 py-2 md:py-[0.75rem]
              hover:text-background! hover:bg-primary-3'
            >
              <span>SIGN UP NOW</span>
              <Image src='/images/icon/plus-white.png' width={17} height={17} alt='' />
            </Button>
          )}
        </div>
      </div>
    </section>
  );
}
